<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const navigationLabel = 'Navegação da central de conexões';

const items = [
  {
    label: 'Visão geral',
    icon: 'i-lucide-layout-grid',
    routeName: 'settings_connections_home',
    section: 'home',
  },
  {
    label: 'Conexões',
    icon: 'i-lucide-inbox',
    routeName: 'settings_inbox_list',
    section: 'inboxes',
  },
  {
    label: 'Biblioteca de IA',
    icon: 'i-lucide-library-big',
    routeName: 'talkvia_openai',
    section: 'ai-library',
  },
  {
    label: 'Assistente IA',
    icon: 'i-lucide-bot',
    routeName: 'agent_bots',
    section: 'assistants',
  },
  {
    label: 'Integrações',
    icon: 'i-lucide-plug',
    routeName: 'settings_applications',
    section: 'integrations',
  },
];

const currentSection = computed(() => route.meta.connectionSection);
</script>

<template>
  <nav
    :aria-label="navigationLabel"
    class="mx-auto mb-5 flex w-full max-w-5xl shrink-0 gap-1 overflow-x-auto rounded-xl border border-n-weak bg-n-solid-1 p-1 shadow-sm"
  >
    <router-link
      v-for="item in items"
      :key="item.section"
      :to="{
        name: item.routeName,
        params: { accountId: route.params.accountId },
      }"
      class="flex min-w-max flex-1 items-center justify-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors"
      :class="
        currentSection === item.section
          ? 'bg-n-brand/10 text-n-brand'
          : 'text-n-slate-11 hover:bg-n-alpha-2 hover:text-n-slate-12'
      "
    >
      <span :class="item.icon" class="size-4" />
      <span>{{ item.label }}</span>
    </router-link>
  </nav>
</template>
